import { deepmerge } from '@mui/utils';
import { createTheme } from '@mui/material';
import grcTheme, {
  themeConstructorArgument as grdThemeConstructorArgument,
} from '@gobo/gobo.react/lib/styles/theme';

import darkPalette from './palette';
import lightPalette from './lightPallete';
import overrides from './overrides';

/**
 * Over here, we're merging theme generated from @gobo/gobo.react with themes present in this project.
 * We have to selectively merge the `palette` and `components` themes, because the rest of the theme is already
 * present in the theme generated from @gobo/gobo.react.
 *
 * Keep in mind that we're only selectively merging `palette` and `components` because as of now, only those theme props are currently being customized
 * in `@gobo/gobo.react`, and as a result, a developer would in most cases only want to override those theme props in this project.
 *
 * How to override theme props in this project:
 *
 * - `palette`: If there was a palette color definied in '@gobo/gobo.react/lib/styles/theme' that you want to override, you can do so by defining the same color in `src/styles/theme/palette.js`.
 * - `components`: If there was a component theme defined in '@gobo/gobo.react/lib/styles/theme' that you want to override, you can do so by defining the same component theme in `src/styles/theme/overrides.js`.
 *
 * Generally, for any palette or component you want to override, recreate the same object from `'@gobo/gobo.react/lib/styles/theme'` that contains those theme here
 * in this project. The `deepmerge` will take care of the rest.
 */
// const {
//   palette: grcPalette,
//   components: grcComponents,
//   ...otherThemeProps // otherThemeProps contains all the theme props that are not `palette` or `components`, that we currently don't want to override.
// } = grcTheme;

// const theme = createTheme({
//   ...otherThemeProps,
//   palette: deepmerge(grcPalette, palette), // using deep merge because theme objects are generally nested objects
//   components: deepmerge(grcComponents, overrides),
// });


const themeConstructorArgument = {
  colorSchemes: {
    dark: {
      palette: darkPalette,
    },
    light: {
      palette: lightPalette,
    },
  },
  components: overrides,
}


const mergedThemeConstructorArgument = deepmerge(grdThemeConstructorArgument, themeConstructorArgument);

const theme = createTheme(mergedThemeConstructorArgument);

export default theme;
